/**
 * SettingsLayout - settings area on the shared SectionShell (same frame as the main app).
 */
import { settingsNavFor } from "@/components/layout/nav/settings-nav";
import { usePlanWorkspace } from "@/hooks/use-platform-billing";
import { usePrpMode } from "@/hooks/use-prp-mode";
import PrpWorkspaceLayout from "@/pages/prp/PrpWorkspaceLayout";
import { SectionShell } from "@/components/layout/SectionShell";
import type { ShellNavItem } from "@/components/layout/shell";
import { useAuth } from "@/hooks/use-auth";

function settingsItemActive(pathname: string, item: ShellNavItem): boolean {
  return pathname === item.href || (item.href !== "/settings" && pathname.startsWith(item.href));
}

/** PRP mode: settings pages open inside the PRP shell (see PracticeLayout). */
export function SettingsLayout() {
  const { prpMode, isLoading } = usePrpMode();
  if (isLoading) return null;
  return prpMode ? <PrpWorkspaceLayout /> : <SettingsLayoutInner />;
}

function SettingsLayoutInner() {
  const { prpOnly, behavioralHealth } = usePlanWorkspace();
  const { user } = useAuth();

  return (
    <SectionShell
      title="Settings"
      subtitle={user?.organization_name}
      searchable
      sections={settingsNavFor({ prpOnly, prp: behavioralHealth })}
      isItemActive={settingsItemActive}
    />
  );
}

export default SettingsLayout;
